import React from 'react';

const ORDER = ['low', 'medium', 'high'];
const COLORS = { low: '#10b981', medium: '#f59e0b', high: '#ef4444' };
const LABELS = { low: 'Low', medium: 'Medium', high: 'High' };

export default function RiskScoreBreakdown({ openByRiskScore = {} }) {
    const max = Math.max(1, ...ORDER.map((k) => openByRiskScore[k] || 0));
    return (
        <section className="dashboard-section">
            <h3>Open by risk score</h3>
            <div className="dashboard-bar-list">
                {ORDER.map((k) => {
                    const n = openByRiskScore[k] || 0;
                    return (
                        <div key={k} className="dashboard-bar">
                            <div
                                className="dashboard-bar-fill"
                                style={{ width: `${(n / max) * 100}%`, background: COLORS[k] }}
                            />
                            <span className="dashboard-bar-label">{LABELS[k]} · {n}</span>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
